import React, { useEffect, useState, useRef } from 'react';
import { jwtDecode } from 'jwt-decode';
import { connect } from 'react-redux';
import * as sharedActions from '../shared/actions/App';
import Submit from '../shared/components/Submit';
import { Modal, Container, Row, Col } from 'react-bootstrap';
import { defineMessages, FormattedMessage } from 'react-intl';
import './SessionExpiration.css';
import * as constants from 'constants/App';
import styled from 'styled-components';
import * as configuration from '../shared/configuration';

const ModalStyled = styled(Modal).attrs({
  dialogClassName: 'custom-modal'
})`
  .custom-modal {
    max-width: 600px;
  }
`;

const messages = defineMessages({
  ok: {
    id: 'ok',
    defaultMessage: 'OK'
  },
  session_expiring_caption: {
    id: 'session_expiring_caption',
    defaultMessage: 'Session Expiring!'
  },
  session_expiring_note: {
    id: 'session_expiring_note',
    defaultMessage:
      'You have been inactive for 30 minutes. Press OK to remain logged in. Otherwise, you will be signed out in 3 minutes.'
  }
});

const SessionExpiration = (props) => {
  const { token, personaToken, dispatch } = props;

  const [show, setShow] = useState(false);
  const modalTimeoutId = useRef(null);
  const inactivityIntervalId = useRef(null);
  const lastActiveTime = useRef(Date.now());

  const resetInactivityTime = () => {
    lastActiveTime.current = Date.now();
  };

  const checkInactivity = () => {
    const now = Date.now();
    const inactiveMinutes = (now - lastActiveTime.current) / (1000 * 60);
    if (!show && inactiveMinutes > configuration.sessionExpirationTimeInMinutes) {
      showModal();
    }
  };

  const setupActivityListeners = () => {
    const events = ['mousemove', 'keydown', 'scroll', 'click'];
    events.forEach(event => window.addEventListener(event, resetInactivityTime));
  };

  const removeActivityListeners = () => {
    const events = ['mousemove', 'keydown', 'scroll', 'click'];
    events.forEach(event => window.removeEventListener(event, resetInactivityTime));
  };

  const showModal = () => {
    setShow(true);
    modalTimeoutId.current = setTimeout(() => {
      handleSessionExpired();
    }, 3 * 60 * 1000); // 3 minutes
  };

 const handleSessionExpired = () => {
  clearTimeout(modalTimeoutId.current); 
  modalTimeoutId.current = null;
  setShow(false);

  dispatch({ type: constants.SIGN_OUT });

  let signedOutPath = '/login?signed_out=1';
  try {
    const jwtToken = jwtDecode(token || personaToken);
    const audien = jwtToken.aud;
    signedOutPath =
      !!personaToken ||
      audien === 'VMS' ||
      audien === 'VMS_MEXICO' ||
      audien === 'ARIEXTERNALSIGNON' ||
      jwtToken.sub === 'ARIUSER'
        ? '/login?signed_out=1'
        : '/sso?signed_out=1';
  } catch (e) {
    signedOutPath = '/login?signed_out=1';
  }

  if (signedOutPath === '/login?signed_out=1') {
    dispatch({ type: constants.NAVIGATE_TO, path: '/login?signed_out=1' });
  } else {
    dispatch({ type: constants.NAVIGATE_TO, path: '/sso?signed_out=1' });
  }
};

  const handleUserResponse = () => {
    clearTimeout(modalTimeoutId.current);
    setShow(false);
    lastActiveTime.current = Date.now();
    dispatch(sharedActions.refreshToken());
  };

  useEffect(() => {
    setupActivityListeners();
    inactivityIntervalId.current = setInterval(checkInactivity, 60 * 1000); // Check every minute

    return () => {
      clearInterval(inactivityIntervalId.current);
      clearTimeout(modalTimeoutId.current);
      removeActivityListeners();
    };
  }, []);

  return (
    <ModalStyled show={show}>
      <Modal.Body>
        <Container style={{ paddingLeft: '20px' }}>
          <Row><Col>&nbsp;</Col></Row>
          <Row>
            <Col>
              <span className="add-service-line-items__caption">
                <FormattedMessage {...messages.session_expiring_caption} />
              </span>
            </Col>
          </Row>
          <Row><Col>&nbsp;</Col></Row>
          <Row>
            <Col>
              <div className="SessionExpiration__note">
                <FormattedMessage {...messages.session_expiring_note} />
              </div>
            </Col>
          </Row>
          <Row><Col>&nbsp;</Col></Row>
          <Row>
            <Col>
              <div className="add-service-line-items__save">
                <Submit
                  caption={<FormattedMessage {...messages.ok} />}
                  imagePath="/assets/VMS_33button_go_bblue.png"
                  onClickHandler={handleUserResponse}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </ModalStyled>
  );
};

const select = (state) => ({
  token: state.appState.getIn(['serverData', 'shared', 'token']),
  personaToken: state.appState.getIn(['serverData', 'shared', 'personaToken'])
});

export default connect(select)(SessionExpiration);
